import type { FC } from "react";
import type { ProductData } from "~/domains/product/types/ProductData";
import { Product } from "~/domains/product/Product";
import { Stack } from "~/common/mui";

interface OrderTableProductProps {
  product: ProductData;
}

export const OrderTableProductV2: FC<OrderTableProductProps> = ({ product }) => {
  return (
    <Stack gap={"4px"}>
      <Product.PdpLink product={product} target="_blank">
        <Product.DesignationV2 variant="bodyLarge" fontWeight={"bold"} color="textPrimary" product={product} />
      </Product.PdpLink>
      {product.shortDescription && (
        <Product.ShortDescriptionV2 variant="bodySmall" color="textSecondary" product={product} />
      )}
    </Stack>
  );
};
